import { render, staticRenderFns } from "./ModalSleep.vue?vue&type=template&id=7cdf96a0&scoped=true&"
import script from "./ModalSleep.vue?vue&type=script&lang=js&"
export * from "./ModalSleep.vue?vue&type=script&lang=js&"
import style0 from "./ModalSleep.vue?vue&type=style&index=0&id=7cdf96a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cdf96a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
installComponents(component, {VCarousel,VCarouselItem})
